module.exports = __webpack_public_path__ + "static/media/texture (17).6938834a.jpg";